import EmailAnswer from './EmailAnswer'

export default EmailAnswer
